/**
 * Accounting Redux Slice
 */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { get } from '../../services/api/axiosInstance';
import { API_ENDPOINTS } from '../../services/api/apiEndpoints';

export const fetchTransactions = createAsyncThunk(
  'accounting/fetchTransactions',
  async (params, { rejectWithValue }) => {
    try {
      const response = await get(API_ENDPOINTS.ACCOUNTING.TRANSACTIONS, params);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message);
    }
  }
);

const accountingSlice = createSlice({
  name: 'accounting',
  initialState: {
    transactions: [],
    accounts: [],
    isLoading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTransactions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchTransactions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.transactions = action.payload.data || action.payload;
      })
      .addCase(fetchTransactions.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = accountingSlice.actions;
export default accountingSlice.reducer;
